import React from 'react'

function Footer() { return (
    <div className="footer-wrapper">
        <div className="eu">
            <img className="modernizace" src="https://nabytekbatka.cz/modernizace.png" />
            <img className="modernizace" src="https://nabytekbatka.cz/publicita-projektu.jpg" />
        </div>
    
      <h3 className="footer-title">
        <a href="https://www.nabytekbatka.cz/"> nabytekbatka.cz </a></h3>
      <div className="footer-bar">
        <ul className="footer-list">
          <li className="menu-item">
            <a className="scroll" href="#services"> služby </a>
          </li>
          <li className="menu-item">
            <a className="scrol" href="#portfolio"> reference </a>
          </li>
          <li className="menu-item">
            <a className="scroll" href="#about"> o nás </a>
          </li>
          <li className="menu-item">
            <a className="scroll" href="#contact"> kontakt </a>
          </li>
        </ul>
        <p className="info"> Dušan Baťka, IČO 69682895 </p>
        <p className="signature">
          design a kód
          <a href="https://www.martinuhlir.com/"> martinuhlir.com </a></p>
      </div>
    </div>
    ); } export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js